import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";

import * as _ from "lodash";
import * as angular from "angular";
import { RecordCreateController, BaseEntityAssociationController } from "./rlAdmin.controllers";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { AttachmentService } from "../services/attachment-service";
import { InventoryService } from "../services/inventory-service";
import { EventService } from "../services/event-service";
import { AclService } from "../services/acl-service";
import { AssetSharedDataService } from "../services/asset-shared-data-service";
import { InventorySharedDataService } from "../services/inventory-shared-data-service";
import { EntityConfigService } from "../services/entity-config-service";
import { AdminService } from "../services/admin-service";
import { SearchService } from "../services/search-service";

export class InventoryCreateController extends RecordCreateController {
    static $inject = ["$scope", "$window", "$timeout", "entityService", "entityConfigService", "notifyService", "attachmentService", "inventoryService", "$q", "aclService"];
    recID: number;
    charTypeID: number;
    multiSelect: boolean;
    selectedIp: string;
    showAssetSearch: boolean;
    selectedRecords: any[];
    selectedFileName: string;
    keyartSrc: string;
    successUrl: string;
    entityID: string;
    parentEntityID: string;
    parentTitle: string;
    templateGroupIDs: number[];
    pickedFile: IFilestackPickFile;
    groupCollapsed: { [groupID: string]: boolean };

    //Parent IP Catalog Item Search
    searchCharTypeID: number;
    searchTemplateID: number;
    searchParentCharTypeID: number;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
    direction: number;
    // --

    canCreate: boolean = false;
    canEdit: boolean = false;

    constructor(private $invScope: ng.IScope, private $invWindow: ng.IWindowService, private $invTimeout: ng.ITimeoutService,
        private invEntityService: EntityService,
        private invEntityConfigService: EntityConfigService, private invNotifyService: NotifyService, private invAttachmentService: AttachmentService,
        private inventoryService: InventoryService, private $q: ng.IQService, private invAclService: AclService) {

        super($invScope, $invWindow, $invTimeout, invEntityService, invEntityConfigService, invNotifyService, invAclService);
        this.recID = 0;
        this.charTypeID = Consts.CharTypeIDs.inventory;
        this.selectedIp = "";
        this.multiSelect = false;
        this.showAssetSearch = false;
        this.selectedRecords = [];
        this.selectedFileName = "";
        this.keyartSrc = "";
        this.entityID = "";
        this.parentEntityID = "";
        this.parentTitle = "";
        this.templateGroupIDs = [Consts.TemplateGroupIDs.IntellectualPropertyTemplateGroup, 2];
        this.groupCollapsed = {};

        this.searchCharTypeID = Consts.CharTypeIDs.property;
        this.direction = 1;

        this.$invScope.$watch(() => this.selectedIp, (newValue: string, oldValue: string) => {
            this.AssignIP(newValue);
        });

        this.$invScope.$watch(() => this.pickedFile,
            (newValue, oldValue) => {
                if (newValue != oldValue && newValue != null) {
                    this.selectedFileName = newValue[0].filename;
                    invNotifyService.notifySuccess("Inventory Item Uploaded");
                    if (_.isNull(this.entityCharDataCollection.charDatas["entity_title"][0].value)) {
                        this.AssignFile(newValue[0].filename);
                    }
                    this.keyartSrc = newValue[0].url;
                }
            }, true);

        this.$invScope.$watch(() => this.showAssetSearch, (newValue, oldValue) => {
            if (!newValue && newValue != oldValue) {
                if (this.selectedRecIdTitlePairs.length == 1) {
                    var singleEntityID = Utils.IdBuilder.buildEntityID(0, this.searchCharTypeID, this.selectedRecIdTitlePairs[0].key);
                    this.selectedIp = singleEntityID;
                }
            }
        });

        this.$invScope.$watch(() => this.templateID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.searchTemplateID = this.templateID;
            }
        });
    }

    InitCreate(charTypeID: number, templateID: number, successUrl: string, cancelUrl: string, templateGroupIDs: number[], isNewAssociation?: boolean, associateToParentEntityID?: string, isParentAssociation?: boolean) {
        this.charTypeID = charTypeID;
        this.groupCollapsed['parentIP'] = false;
        this.searchTemplateID = templateID;
        this.searchParentCharTypeID = this.charTypeID;
        this.Init(charTypeID, templateID, successUrl, cancelUrl, templateGroupIDs, isNewAssociation, associateToParentEntityID, isParentAssociation);
    }

    ToggleAssetSearch() {
        this.showAssetSearch = !this.showAssetSearch;
    }

    AssignIP(assetID: string) {
        if (assetID != null && assetID != "") {
            this.selectedIp = assetID;
            this.invEntityService.getEntity(assetID).then((result) => {
                this.parentTitle = result.record.title;
                this.parentEntityID = result.record.id;
            });
            this.showAssetSearch = false;
            this.invNotifyService.broadcastDone();
        }
    }

    AssignFile(fileName: string) {
        this.entityCharDataCollection.charDatas["entity_title"][0].value = fileName;
    }

    SaveEntity() {
        this.invNotifyService.startProgress();

        return this.CreateEntity()
            .then(() => {
                var promises = [];

                if (this.selectedFileName != "") {
                    var promise1 = this.MoveAttachmentFromTempAttachment();
                    promises.push(promise1);
                }

                if (this.selectedIp != "") {
                    var promise2 = this.AssociateParentIP();
                    promises.push(promise2);
                }

                if (promises.length > 0) {
                    this.$q.all(promises)
                        .then(() => {
                            this.$invTimeout(() => {
                                this.$invWindow.location.assign(this.successUrl);
                            });
                        },
                        () => {//roll back entity created
                            this.invEntityService.deleteEntity(this.entityID)
                                .then(() => { this.invNotifyService.notifyError("Entity Create rolled back."); });
                        });
                } else {
                    this.$invTimeout(() => {
                        this.$invWindow.location.assign(this.successUrl);
                    });
                }
            })
            .finally(() => {
                this.invNotifyService.endProgress();
            });
    }

    //Create Entity in db and return id
    CreateEntity(): ng.IPromise<any> {
        var templateID = Utils.IdBuilder.buildTemplateID(this.divisionID, this.charTypeID, this.templateID);
        return this.invEntityService.createEntity(templateID, this.associateToParentEntityID, this.entityCharDataCollection.charDatas, true)
            .then((result) => {
                if (result.success) {
                    //If the user does not have Write access, then redirect them to the newly created entity, NOT the Contacts Association page
                    if (!this.canEdit) {
                        this.successUrl = "/Go/" + result.entityID;
                    }
                    else {
                        this.recID = Utils.IdBuilder.splitEntityID(result.entityID).recID;
                        this.successUrl = this.successUrl.replace("-1", this.recID.toString());

                        //clk 10/5/2015, not sure what any of the below is for any longer
                        if (this.isNewAssociation) {
                            this.successUrl = this.successUrl.replace("-2", this.associateToParentEntityID);
                            //Associate the deal to the parent entity id
                            this.DoAssociation(result.entityID);
                            this.successUrl += "&an=1";
                        }
                        else if (!this.isNewAssociation && this.associateToParentEntityID != null && this.associateToParentEntityID != "-1") {
                            this.successUrl = this.successUrl.replace("-2", this.associateToParentEntityID);
                            this.CopyParentRelationships(result.entityID);
                        }
                    }

                    this.editMode = false;

                } else {
                    this.invNotifyService.notifyError("There was an error creating your entity.");
                }
            }, () => {
                this.saving = false;
                this.invNotifyService.notifyError("There was an error creating your entity.");
            });
    }
    //end Create Entity in db and return id

    //create association between parentIP and inventory item
    AssociateParentIP() {
        var createInventoryAssociationsRequest: Models.ICreateInventoryAssociationsModel = {
            parentRecID: Utils.IdBuilder.splitEntityID(this.selectedIp).recID,
            parentCharTypeID: Consts.CharTypeIDs.property,
            childCharTypeID: Consts.CharTypeIDs.inventory,
            childRecIDs: [this.recID]
        };
        return this.inventoryService.createAssociations(createInventoryAssociationsRequest)
            .then(() => { this.invNotifyService.notifySuccess("Parent IP has been linked."); },
            () => {
                this.invNotifyService.notifyError("There was an error associating the inventory attachment to the parent IP.");
            });
    }

    //after save, relate attachment to new inventory record and move it from temp bucket
    MoveAttachmentFromTempAttachment(): ng.IPromise<any> {
        var request: Models.IEntityAttachmentRequest = {
            charTypeID: this.charTypeID,
            recID: this.recID,
            path: this.pickedFile.key,
            name: this.pickedFile.filename,
            attachmentTypeID: Consts.AttachmentTypes.Original,
            makeKeyArt: false,
            makeThumb: false
        };
        return this.invAttachmentService.saveAttachment(request)
            .then(() => { this.invNotifyService.notifySuccess("Attachment Saved."); },
            () => {
                this.invNotifyService.notifyError("There was an error saving the inventory attachment.");
            });
    }

    //end save
    ToggleOpen(groupID: string) {
        this.groupCollapsed[groupID] = !this.groupCollapsed[groupID];
    }

}

export class InventoryDetailController {
    static $inject = ["$scope", "entityService", "notifyService", "eventService", "$window", "inventoryService", "$q", "aclService"];

    entityID: string;
    entityRecord: Models.IEntity;
    entityCharDataCollection: Models.ICharDataCollection;
    canEdit: boolean;
    editMode: boolean;
    visibility: number;
    isValid: boolean;
    charTypeID: number;
    parentEntityID: string;
    parentTitle: string;
    selectedIp: string;
    recID: number;
    showAssetSearch: boolean;
    templateGroupIDs: number[];
    singleSelect: boolean;
    groupCollapsed: { [groupID: string]: boolean };
    selectedEntity: any;
    locked: boolean;
    initialized: boolean;
    searchCharTypeID: number = Consts.CharTypeIDs.property;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
    direction: number = 1;

    constructor(private $scope: IRLInventoryDetailControllerScope, private entityService: EntityService, private notifyService: NotifyService,
        private eventService: EventService,
        private $window: ng.IWindowService,
        private inventoryService: InventoryService,
        private $q: ng.IQService,
        private aclService: AclService
    ) {
        this.entityID = "";
        this.entityRecord = null;
        this.entityCharDataCollection = null;
        this.editMode = false;
        this.visibility = 1;
        this.canEdit = false;
        this.isValid = false;
        this.parentEntityID = "";
        this.parentTitle = "";
        this.selectedIp = "";
        this.recID = 0;
        this.showAssetSearch = false;
        this.templateGroupIDs = [Consts.TemplateGroupIDs.IntellectualPropertyTemplateGroup, 2];
        this.singleSelect = true;
        this.groupCollapsed = {};
        this.charTypeID = Consts.CharTypeIDs.inventory;
        this.locked = false;
        this.initialized = false;

        this.$scope.$watch(() => this.selectedIp, (newValue: string, oldValue: string) => {
            this.AssignIP(newValue);
        });

        $scope.$watch(() => {
            if (this.entityID == null) {
                return null;
            } else {
                return this.entityID;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        return this.LoadEntity();
                    });
                }
            });

        this.$scope.$on(Consts.Events.ViewEntity, (e, data) => {
            if (!_.isEmpty(data)) {
                this.ViewEntity(data);
            }
        });

        this.$scope.$watch(() => this.showAssetSearch, (newValue, oldValue) => {
            if (!newValue && newValue != oldValue) {
                if (this.selectedRecIdTitlePairs.length == 1) {
                    var singleEntityID = Utils.IdBuilder.buildEntityID(0, this.searchCharTypeID, this.selectedRecIdTitlePairs[0].key);
                    this.selectedIp = singleEntityID;
                }
            }
        });
    }

    Init(entityID: string) {
        this.entityID = entityID;
        this.recID = Utils.IdBuilder.splitEntityID(entityID).recID;
        this.LoadEntity();
        this.LoadParentIP();
        this.groupCollapsed['parentIP'] = false;

        this.aclService.loadActivityAcls()
            .then((acls) => {
                this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod17.Details);
            });
    }

    LoadEntity(): ng.IPromise<any> {
        this.notifyService.startProgress();
        return this.entityService.getEntity(this.entityID)
            .then((result) => {
                this.entityRecord = result.record;
                this.entityCharDataCollection = result.charDataCollection;
                this.initialized = true;
                if (result.charDataCollection.status.lockIndicator > 0) {
                    this.locked = true;
                }
                else {
                    this.locked = false;
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    SaveEntity() {
        this.notifyService.startProgress();
        return this.entityService.saveCharData(this.entityID, this.entityCharDataCollection.charDatas)
            .then(() => {
                this.notifyService.notifySuccess("Successfully Saved");
            }, this.notifyService.errorResponseHandler)
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Edit() {
        this.editMode = true;
    }

    Cancel() {
        this.notifyService.startProgress();
        this.LoadEntity()
            .then(() => {
                this.editMode = false;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }
    //create association between parentIP and inventory item
    AssociateParentIP() {
        var createInventoryAssociationsRequest: Models.ICreateInventoryAssociationsModel = {
            parentRecID: Utils.IdBuilder.splitEntityID(this.selectedIp).recID,
            parentCharTypeID: Consts.CharTypeIDs.property,
            childCharTypeID: Consts.CharTypeIDs.inventory,
            childRecIDs: [this.recID]
        };
        return this.inventoryService.createAssociations(createInventoryAssociationsRequest)
            .then(() => { this.notifyService.notifySuccess("Parent IP has been linked."); },
            () => {
                this.notifyService.notifyError("There was an error associating the inventory attachment to the parent IP.");
            });
    }

    Save(isValid: boolean) {
        if (!isValid) {
            this.notifyService.notifyError("Correct Errors");
        } else {
            this.notifyService.startProgress();

            var promise1 = this.SaveEntity();
            var promise2 = this.DeleteAssociations();
            var promise3 = this.CreateAssociations();


            this.$q.all([promise1, promise2, promise3])
                .then(() => {
                    this.editMode = false;
                    this.LoadEntity();
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }

    }

    DeleteAssociations() {
        if (this.selectedIp.length > 0) {
            this.entityService.getEntityParentRelationship(this.entityID, Consts.CharTypeIDs.property)
                .then((result) => {
                    if (result.length > 0) {
                        for (var ii = 0; ii < result.length; ii++) {
                            var deleteInventoryAssociationsRequest: Models.IDeleteInventoryAssociationsModel = {
                                parentRecID: result[ii].parentRecID,
                                parentCharTypeID: Consts.CharTypeIDs.property,
                                relRecIDs: [result[ii].relRecID]
                            };
                            return this.inventoryService.deleteAssociations(deleteInventoryAssociationsRequest);
                        }
                    }
                });
        }
        else {
            return null;
        }
    }

    CreateAssociations() {
        if (this.selectedIp.length > 0) {
            return this.AssociateParentIP();
        }
        else {
            return null;
        }
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Inventory?") && this.$window.confirm("Are you REALLY SURE you want to delete this Inventory?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.entityRecord.id)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.InventoryListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Inventory");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    RefreshAll(): ng.IPromise<any> {
        return this.RefreshValidation();
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    //get associated parent IP
    LoadParentIP() {
        this.notifyService.startProgress();
        return this.entityService.getEntityParentRelationship(this.entityID, Consts.CharTypeIDs.property)
            .then((result) => {
                if (result.length > 0) {
                    this.parentEntityID = Utils.IdBuilder.buildEntityID(result[0].divisionID, result[0].parentCharTypeID, result[0].parentRecID);
                    this.entityService.getEntityRecord(this.parentEntityID)
                        .then((entityResult) => {
                            this.parentTitle = entityResult.title;
                        },
                        () => {
                            this.parentTitle = "";
                        });
                }
            },
            () => {
                //this.invNotifyService.notifyError("Error loading up Parent IP");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }
    //end get associated parent IP

    // ip selection
    ToggleAssetSearch() {
        this.showAssetSearch = !this.showAssetSearch;
    }

    AssignIP(assetID: string) {
        if (assetID != null && assetID != "") {
            this.selectedIp = assetID;
            this.entityService.getEntity(assetID).then((result) => {
                this.parentTitle = result.record.title;
                this.parentEntityID = result.record.id;
            });
            this.showAssetSearch = false;
            this.notifyService.broadcastDone();
        }
    }
    //end ip selection

    ToggleOpen(groupID: string) {
        this.groupCollapsed[groupID] = !this.groupCollapsed[groupID];
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    ViewEntity(viewEntityID: string) {
        this.entityService.getEntity(viewEntityID)
            .then((res) => {
                this.selectedEntity = res;
            });
    }
}

export interface IRLInventoryDetailControllerScope extends ng.IScope {
    pickedFile: IFilestackPickFile;
}

export class InventoryFilesController {
    static $inject = ["$scope", "$sce", "$q", "$window", "notifyService", "assetSharedDataService", "eventService", "entityService"];

    inventoryID: string;
    visibility: number;
    initialized: boolean;
    docsInitialized: boolean;
    locked: boolean;
    editDocumentID: string;

    constructor(private $scope: ng.IScope,
        private $sce: ng.ISCEService,
        $q: ng.IQService,
        private $window: ng.IWindowService,
        private notifyService: NotifyService,
        private sharedData: AssetSharedDataService,
        private eventService: EventService,
        private entityService: EntityService) {

        this.inventoryID = "";
        this.visibility = 1;
        this.initialized = false;
        this.docsInitialized = true;
        this.editDocumentID = null;
        this.locked = false;

        $scope.$watch(
            () => this.sharedData.asset != null ? this.sharedData.asset.charDataCollection.status.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            });
    }

    Init(inventoryID: string) {
        this.inventoryID = inventoryID;
        this.notifyService.startProgress();
        this.sharedData.RefreshFiles(this.inventoryID)
            .then(() => {
                this.initialized = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }



    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Inventory?") && this.$window.confirm("Are you REALLY SURE you want to delete this Inventory?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.inventoryID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.InventoryListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Inventory");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    RefreshAll(): ng.IPromise<any> {
        return this.RefreshValidation()
            .then(() => {
                this.docsInitialized = false;
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }
}



export class InventoryEntityAssociationSearchController extends BaseEntityAssociationController {
    static $inject = ["$scope", "$location", "$filter", "notifyService", "$window", "$q",
        "eventService", "entityService", "entityConfigService", "adminService", "$interval", "searchService", "inventorySharedDataService", "aclService"];

    //Search objects
    keywords: string;
    pages: { [key: number]: number };
    templates: { [key: string]: Models.IKeyValuePair<string, number>[] };
    sortDirs: { [key: number]: string };
    sortFields: { [key: number]: string };
    selectedCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
    selectedTemplate: string;
    selectedStatus: string;
    searchStates: { [key: string]: Models.IAdvancedSearchModel };
    templateFacets: Models.IKeyValuePair<string, string>[];
    statusFacets: Models.IKeyValuePair<string, string>[];

    //Associations objects
    sharedData: InventorySharedDataService;
    filterByEntityID: string;
    charTypesAndTemplateGroups: Models.IAssociationCharTypeAndTemplateGroupExtended[];
    selectedRecords: any[];
    associateCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
    locked: boolean;
    currentCharTypeAndTemplateGroup: Models.IAssociationCharTypeAndTemplateGroupExtended;
    canCreate: boolean = false;
    canEdit: boolean = false;
    currentCharTypeName: string;
    refreshAssociationPanels: boolean;
    initialized: boolean;

    constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private $filter: ng.IFilterService,
        public notifyService: NotifyService, private $window: ng.IWindowService,
        public $q: ng.IQService,
        private eventService: EventService,
        private entityService: EntityService,
        private entityConfigService: EntityConfigService,
        public adminService: AdminService,
        public $interval: ng.IIntervalService,
        private searchService: SearchService,
        private inventorySharedDataService: InventorySharedDataService,
        private aclService: AclService) {

        super($scope, notifyService, adminService, $interval, $q, entityService, eventService);

        //Search objects
        this.keywords = "";
        this.pages = {};
        this.templates = {};
        this.sortDirs = {};
        this.sortFields = {};
        this.selectedCharType = null;
        this.selectedTemplate = null;
        this.searchStates = {};
        this.templateFacets = [];
        this.statusFacets = [];

        //Associations objects
        this.sharedData = inventorySharedDataService;
        this.filterByEntityID = "";
        this.charTypesAndTemplateGroups = [];
        this.selectedRecords = [];
        this.locked = false;
        this.currentCharTypeAndTemplateGroup = { name: "", createName: "", charTypeID: 0, tgIDs: [], isParentChar: false };
        this.currentCharTypeName = "";
        this.refreshAssociationPanels = false;
        this.initialized = false;

        $scope.$watch(() => this.sharedData.inventoryStatus != null ? this.sharedData.inventoryStatus.lockIndicator : 1,
            (newvalue, oldvalue) => {
                this.locked = newvalue > 0;
            });
    }

    CharTypeChanged() {
        this.selectedTemplate = null;
        this.selectedStatus = null;
        this.BuildSearchStates();
    }

    TemplateChanged() {
        this.selectedStatus = null;
        this.BuildSearchStates();
    }

    StatusChanged() {
        this.BuildSearchStates();
    }

    Init(filterByEntityID: string, charTypeName: string, charTypeID: string, templateID: string) {
        this.filterByEntityID = filterByEntityID;
        this.baseEntityID = filterByEntityID;
        this.currentCharTypeName = charTypeName;

        //Get ACLs for user
        this.entityService.getEntityRecord(filterByEntityID)
            .then((result) => {
                var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
                this.canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);
                this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
            });

        this.LoadTemplateGroups();
        this.sharedData.RefreshInventory(filterByEntityID);
        this.sharedData.RefreshInventoryStatus(filterByEntityID)
            .then(() => {
                this.initialized = true;
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        this.refreshAssociationPanels = true;
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    LoadTemplateGroups() {
        this.notifyService.startProgress();

        //Hardcoded list of valid char types per Joe N.
        //16, 1, 17, 4, 15, and 7
        var validCharTypes = [16, 1, 4, 17, 15, 7];

        this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.inventory)
            .then((results) => {

                _.forEach(results, (result) => {
                    var charName = result.charTypeName;

                    if (charName == "Transaction") {
                        charName = "Deals";
                    }
                    else if (charName == "Work Orders") {
                        charName = "Jobs";
                    }
                    else if (charName == "Property") {
                        charName = "Catalog Items";
                    }
                    else if (charName == "Invoice") {
                        charName = "Accounting";
                    }

                    if (validCharTypes.indexOf(result.charTypeID) > -1) {
                        this.charTypesAndTemplateGroups.push({
                            name: charName,
                            createName: charName,
                            charTypeID: result.charTypeID,
                            tgIDs: [1],
                            isParentChar: false
                        });

                        if (this.currentCharTypeName == charName) {
                            this.currentCharTypeAndTemplateGroup = {
                                name: charName,
                                createName: charName,
                                charTypeID: result.charTypeID,
                                tgIDs: [],
                                isParentChar: false
                            }
                        }
                    }
                });
            })
            .finally(() => {
                this.entityConfigService.getRelatedConfigurationParentCharacteristicTypes(Consts.CharTypeIDs.inventory)
                    .then((results) => {
                        _.forEach(results, (result) => {
                            var charName = result.charTypeName;

                            if (charName == "Transaction") {
                                charName = "Deals";
                            }
                            else if (charName == "Work Orders") {
                                charName = "Jobs";
                            }
                            else if (charName == "Property") {
                                charName = "Catalog Items";
                            }
                            else if (charName == "Invoice") {
                                charName = "Accounting";
                            }

                            var charType = { name: charName, createName: charName, charTypeID: result.charTypeID, tgIDs: [1], isParentChar: true }

                            //Check to see if the array already has reference to this charType.  If so, we just want to flip the isParentChar flag to true
                            //If not, add the new charType

                            var matchingCharTypes = this.charTypesAndTemplateGroups.filter(ct => ct.charTypeID == result.charTypeID);

                            if (validCharTypes.indexOf(result.charTypeID) > -1) {
                                if (matchingCharTypes.length > 0) {
                                    var index = this.charTypesAndTemplateGroups.indexOf(matchingCharTypes[0]);
                                    this.charTypesAndTemplateGroups[index].isParentChar = true;
                                }
                                else {
                                    this.charTypesAndTemplateGroups.push(charType);
                                }

                                if (this.currentCharTypeName == charName) {
                                    this.currentCharTypeAndTemplateGroup = {
                                        name: charName,
                                        createName: charName,
                                        charTypeID: result.charTypeID,
                                        tgIDs: [],
                                        isParentChar: true
                                    }
                                }
                            }
                        });
                    })
                    .finally(() => {
                        //Sort the list based on how Joe wants it
                        //Projects, Catalog Items, Deals, Inventory, Jobs, Accounting
                        var sortList = [16, 1, 4, 17, 15, 7];

                        var sorted = _.sortBy(this.charTypesAndTemplateGroups, function (obj) {
                            return _.indexOf(sortList, obj.charTypeID);
                        });

                        var currentCharTypeIndex = _.findIndex(sorted, c => c.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID);

                        this.SortByIndex(sorted, currentCharTypeIndex, 0);

                        this.charTypesAndTemplateGroups = sorted;

                        this.BuildSearchStates();
                        this.notifyService.endProgress();
                    });
            });
    }

    SortByIndex(collection: any[], fromIndex: number, toIndex: number) {
        collection.splice(toIndex, 0, collection.splice(fromIndex, 1)[0]);
    }

    SearchSubmit() {
        this.BuildSearchStates();
    }

    BuildSearchStates() {
        var tempSearchStates: { [key: string]: Models.IAdvancedSearchModel } = {};
        this.searchStates = {};

        var selectedCharTypeID = null;

        if (this.selectedCharType != null) {
            selectedCharTypeID = this.selectedCharType.charTypeID;
        }

        //associations
        var metaDataSearchRequest: Models.IAdvancedSearchModel = {
            charTypeID: selectedCharTypeID,
            searchGroups: [],
            keywords: this.keywords,
            page: this.pages[selectedCharTypeID] || 1,
            rowCount: 10,
            templateGroupIDs: [1, 2],
            template: this.selectedTemplate,
            status: this.selectedStatus,
            sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
            sortField: this.sortFields[selectedCharTypeID] || "",
            relatedEntityID: this.filterByEntityID
        };

        this.searchService.advancedSearch(metaDataSearchRequest)
            .then((res) => {
                this.templateFacets = res.getTemplateFacets();
                this.statusFacets = res.getStatusFacets();
            })
        // end reflective association search

        if (this.selectedCharType != null) {
            var searchState: Models.IAdvancedSearchModel = {
                charTypeID: selectedCharTypeID,
                searchGroups: [],
                keywords: this.keywords,
                page: this.pages[selectedCharTypeID] || 1,
                rowCount: 10,
                templateGroupIDs: [1, 2],
                template: this.selectedTemplate,
                status: this.selectedStatus,
                sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
                sortField: this.sortFields[selectedCharTypeID] || "",
                relatedEntityID: this.filterByEntityID,
                explicitRelationshipsOnly: true
            };

            tempSearchStates[this.selectedCharType.name] = searchState;
        }
        else {
            _.each(this.charTypesAndTemplateGroups, ct => {
                var searchState: Models.IAdvancedSearchModel = {
                    charTypeID: ct.charTypeID,
                    searchGroups: [],
                    keywords: this.keywords,
                    page: this.pages[selectedCharTypeID] || 1,
                    rowCount: 10,
                    templateGroupIDs: [1, 2],
                    template: this.selectedTemplate,
                    status: this.selectedStatus,
                    sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
                    sortField: this.sortFields[selectedCharTypeID] || "",
                    relatedEntityID: this.filterByEntityID,
                    explicitRelationshipsOnly: true
                };

                tempSearchStates[ct.name] = searchState;
            });
        }

		var keys = _.keys(tempSearchStates);
		keys.forEach(k => {
			var searchState = tempSearchStates[k];
			if (searchState.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID) {
				searchState.filterByEntityID = this.filterByEntityID;
				searchState.keywords = this.filterByEntityID;
				searchState.relatedEntityID = "";
			}
		});

        this.searchStates = tempSearchStates;
    }

    ClearSearch($event?: ng.IAngularEvent) {
        if ($event != null) {
            $event.preventDefault();
        }
        this.keywords = "";
        this.BuildSearchStates();
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Inventory?") && this.$window.confirm("Are you REALLY SURE you want to delete this Inventory?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.filterByEntityID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.InventoryListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Inventory");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    ViewEntity(viewEntityID: string) {
        this.entityService.getEntity(viewEntityID)
            .then((res) => {
                this.selectedEntity = res;
            });
    }
}
